import { Text } from '@mantine/core';

import { Collateral } from 'models';
import { CollateralGroup, CollateralHelpers } from 'helpers/CollateralHelpers';

import { CollateralCover } from 'components/collateral/CollateralCover';
import { FileTeaser } from 'components/file-teaser/FileTeaser';

import cx from './CollateralTeaser.module.scss';

const CollateralTeaser = ({
    collateral,
    title,
    href,
    group,
    withCaption = true,
}: {
    collateral: Collateral;
    title: string;
    href: string;
    group?: CollateralGroup;
    withCaption?: boolean;
}) => {
    const withTitleOverlay = CollateralHelpers.isPlayable(collateral);
    const caption =
        !group || group === CollateralGroup.DOCUMENTS
            ? CollateralHelpers.caption(collateral)
            : CollateralHelpers.categoryLabel(collateral);

    return (
        <FileTeaser
            href={href}
            shape={
                group === CollateralGroup.VIDEOS
                    ? 'landscape'
                    : group === CollateralGroup.IMAGES
                      ? 'square'
                      : 'portrait'
            }
            file={withTitleOverlay ? null : CollateralHelpers.file(collateral)}
            cover={
                <CollateralCover
                    collateral={collateral}
                    width={group === CollateralGroup.VIDEOS ? 360 : 240}
                    alt={title}
                    iconSize={32}
                />
            }
            overlay={
                withTitleOverlay && (
                    <Text component="span" size="sm" fw={600} lineClamp={2} className={cx.overlayTitle}>
                        {title}
                    </Text>
                )
            }
            title={withCaption && !withTitleOverlay ? title : undefined}
            meta={withCaption ? caption : undefined}
        />
    );
};

export { CollateralTeaser };
